import * as chmln from "@chamaeleonidae/chmln";
import { datadogRum } from "@datadog/browser-rum";
import { LoginResponseBodyUserType } from "@intelligems/ig-types";
import * as Sentry from "@sentry/react";
import { mpLogin, mpLogout } from "@src/utils/mixpanel";

export const setUser = (user: LoginResponseBodyUserType | null) => {
  if (user) {
    const name = user.user.lastName
      ? `${user.user.firstName} ${user.user.lastName}`
      : `${user.user.firstName}`;

    Sentry.setUser({
      id: user.user.id,
      username: user.user.email,
      email: user.user.email,
      name,
    });

    if (window.clarity) {
      window.clarity(
        "identify",
        user.user.id,
        undefined,
        undefined,
        user.user.email
      );
      window.clarity("set", "orgId", user.organization.id);
    }
    mpLogin(user);
    datadogRum.setUser({
      id: user.user.id,
      email: user.user.email,
      name,
      organizationId: user.organization.id,
      shopId: user.organization.shopId!,
    });
    chmln.identify(user.user.id, {
      email: user.user.email,
      name,
      uid_hash: user.chameleonHmac,
    });
  } else {
    Sentry.setUser(null);
    mpLogout();
    datadogRum.clearUser();
  }
};
